interface GenerateMediaImageUrlProps {
	mediaApiFileId: string;
	mediaClientId: string;
	mediaExternalEndpointUrl: string;
	mediaEndpoint: 'binary' | 'image';
	token?: string;
	width?: number;
	height?: number;
	'max-age'?: number;
	mode?: string;
	collection?: string;
}
/*
 * Generate background image url for a file uploaded to media
 */
export function generateMediaImageUrl({
	mediaApiFileId,
	mediaClientId,
	mediaExternalEndpointUrl,
	mediaEndpoint,
	...queryParams
}: GenerateMediaImageUrlProps) {
	const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);

	url.searchParams.append('client', mediaClientId);
	Object.entries(queryParams).forEach(([param, value]) =>
		url.searchParams.append(param, String(value)),
	);

	return url.toString();
}
